/* eslint-disable react/no-unstable-nested-components */
import * as React from 'react'
import { DayPicker } from 'react-day-picker'
import { Button, buttonVariants } from '@/components/ui'
import { cn } from '../../lib/utils'
// import { buttonVariants } from "@/components/ui/button"

export type CalendarProps = React.ComponentProps<typeof DayPicker>

const Calendar = ({ className, classNames, showOutsideDays = true, ...props }: CalendarProps) => (
  <DayPicker
    showOutsideDays={showOutsideDays}
    className={cn(`p-2`, className)}
    classNames={{
      // root: `flex flex-col items-center justify-center w-full`,
      months: `relative`,
      month: `space-y-4`,
      weekdays: `flex justify-between w-full`,
      weekday: `text-sm p-1`,
      dropdowns: `flex items-center justify-between`,
      dropdown: `px-2 py-1.5 rounded-md bg-popover text-popover-foreground text-sm  focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background`,
      caption_dropdowns: `flex gap-3`,
      caption: `flex justify-between pt-0.5 relative items-center`,
      caption_label: `hidden`,
      vhidden: `hidden`,
      nav: `hidden`,
      button_previous: `absolute left-1`,
      button_next: `absolute right-1`,
      table: `border-collapse space-y-0.5`,
      head: `w-full`,
      head_row: `flex`,
      head_cell: `text-muted-foreground rounded-md w-8 font-normal text-[0.8rem]`,
      row: `flex w-full mt-1`,
      cell: `h-8 w-8 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20`,
      day: cn(buttonVariants({ variant: `ghost` }), `h-8 w-8 p-0 font-normal aria-selected:opacity-100`),
      range_end: `day-range-end`,
      selected: `bg-blue-100 text-primary-foreground hover:bg-blue-100 hover:text-primary-foreground focus:bg-blue-100 focus:text-primary-foreground`,
      today: `bg-secondary text-accent-foreground`,
      outside: `day-outside text-muted-foreground opacity-50 aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30`,
      disabled: `text-muted-foreground opacity-50`,
      range_middle: `aria-selected:bg-accent aria-selected:text-accent-foreground`,
      hidden: `invisible`,
      ...classNames
    }}
    components={{
      DayButton: ({ day, children, ...rest }) => (
        <Button variant='ghost' {...rest} className='h-full w-full font-normal aria-selected:opacity-100'>
          {children}
        </Button>
      )
    }}
    {...props}
  />
)
Calendar.displayName = `Calendar`

export { Calendar }
